import { useNavigate } from "react-router-dom";
import { FileUploadField, UploadType } from "./uploadFileModal";
import { FileLabel, SecondaryLabel } from "shared/types/file";

interface UploadFileNavigationProps {
  skipFields?: FileUploadField[];
  buildings?: string[];
  building?: any;
  unit?: any;
  customLabels?: FileLabel[] | any;
  defaultFileLabel?: FileLabel;
  defaultSecondaryLabel?: SecondaryLabel;
  incomingCustomData?: any;
  uploadType?: UploadType;
  selectedFirstCounterparty?: { id: number | null; name: string };
  variant?: "light" | "extended";
}

export const useUploadFileNavigation = () => {
  const navigate = useNavigate();

  const navigateToUploadFiles = (props: UploadFileNavigationProps) => {
    navigate("/upload-files", { state: props });
  };

  return { navigateToUploadFiles };
};

// Helper component for backwards compatibility
interface UploadFileModalProps extends UploadFileNavigationProps {
  isOpen: boolean;
  onOpenChange?: any;
  onClose?: (fileLog?: any) => void;
  onSave?: (fileLog: any) => void;
  onFileUploadSuccess?: (uploadSuccessResult: any) => void;
}

const UploadFileModalNavigator = ({
  isOpen,
  onClose,
  onOpenChange,
  onSave,
  onFileUploadSuccess,
  ...props
}: UploadFileModalProps) => {
  const { navigateToUploadFiles } = useUploadFileNavigation();

  // When modal is opened, navigate to the page instead
  if (isOpen) {
    // Don't pass callbacks through navigation state - they can't be serialized
    navigateToUploadFiles(props);

    // Close the modal immediately since we're navigating away
    if (onOpenChange) onOpenChange(false);
    if (onClose) onClose();
  }

  // This component doesn't render anything since it redirects
  return null;
};

export default UploadFileModalNavigator;